const PlanOrder = ['community', 'plus', 'team', 'enterprise'] as const
type Plan = (typeof PlanOrder)[number]

export function isPaywalled(currentPlan: Plan, minPlan: Plan): boolean {
  return PlanOrder.indexOf(currentPlan) < PlanOrder.indexOf(minPlan)
}
